import { saveAs } from "file-saver";

// Testuj.to "recommended" seals — one baked asset per recommend-%, grouped by year (the year is
// baked into the artwork). The design set covers 80–100; campaigns that scored below 80 % are not
// awarded a seal at all.
const STAMP_MIN = 80;
const STAMP_MAX = 100;

// Years we have a baked seal set for, under public/images/stamps/<year>/<pct>.png.
// Add a new folder AND a new entry here when a new year's artwork ships.
const STAMP_YEARS = [2025, 2026];

// Pick the seal set for a campaign's year. Exact match when we have it; otherwise clamp to the
// nearest available year (older-than-oldest → oldest set, newer-than-newest → newest set) so a
// campaign always gets a seal, just with the closest year's artwork.
const resolveStampYear = (year?: number): number => {
    const min = Math.min(...STAMP_YEARS);
    const max = Math.max(...STAMP_YEARS);
    if (!year) {
        return max;
    }
    if (year <= min) {
        return min;
    }
    if (year >= max) {
        return max;
    }
    return STAMP_YEARS.includes(year) ? year : max;
};

// URL of the seal matching the campaign's recommend-% and year, or null when the campaign scored
// below the 80 % award threshold (79 % and less get no seal).
export const stampBadgeSrc = (recommend: number, year?: number): string | null => {
    const value = Math.round(recommend);
    if (value < STAMP_MIN) {
        return null;
    }
    const percent = Math.min(STAMP_MAX, value);
    return `/images/stamps/${resolveStampYear(year)}/${percent}.png`;
};

// Download the matching seal as a PNG (the value + year are baked into the asset). No-op when the
// campaign didn't earn a seal.
export const downloadStampBadge = (recommend: number, year?: number, filename = "razitko.png"): void => {
    const src = stampBadgeSrc(recommend, year);
    if (!src) {
        return;
    }
    saveAs(src, filename);
};
